import { User } from 'firebase/auth';
import { makeAutoObservable } from 'mobx';
import { UserDataChangedCallback } from '../firebaseConnection/authentication';

export default class AuthStore {
  public userData: User | null;

  public loading: boolean;

  public isFrontendAdmin: boolean;

  constructor(
    registerAuthChanged: (callback: UserDataChangedCallback) => unknown,
  ) {
    makeAutoObservable(this);
    this.userData = null;
    this.loading = true;
    this.isFrontendAdmin = false;
    registerAuthChanged(user => {
      this.userData = user;
      this.loading = false;
      this.isFrontendAdmin = !!user?.isFrontendAdmin;
    });
  }
}
